import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'

import myLibraryActions from 'redux/actions/my_library_actions'
import AddToFolder from 'views/modals/add_to_folder_modal'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import { myLibrarySelectors } from 'redux/selectors'

class PrivateLibraryAddToFolderModal extends React.Component {

	constructor() {
		super()
		this.createNewFolder = this.createNewFolder.bind(this)
		this.saveLesson = this.saveLesson.bind(this)
		this.cancelAction = this.cancelAction.bind(this)
	}

	createNewFolder() {
		this.props.actions.addToNewFolderSelected(this.props.entity)
	}

	saveLesson(folder_id) {
		this.props.actions.addToFolderSelected(this.props.entity.data.entityUID, folder_id)
	}

	cancelAction() {
		this.props.actions.closeModal()
	}

	render() {
		return (
			<AddToFolder
				closeModal={this.props.actions.closeModal}
				cancel={this.cancelAction}
				modalName={this.props.modalName}
				modalTitle={this.props.modal_title}
				createNewText={this.props.createNewText}
				folderName={this.props.folderName}
				createNewFolder={this.createNewFolder}
				folders={this.props.folders}
				saveLesson={this.saveLesson} />
		)
	}
}

PrivateLibraryAddToFolderModal.propTypes = {
	modalName: PropTypes.string,
	lesson: PropTypes.object,
}

function mapStateToProps(state) {
	return myLibrarySelectors.myLibraryAddToFolderSelector(state)
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		closeModal: myLibraryActions.addToFolderCancel,
		addToFolderSelected: myLibraryActions.addToFolderSelected,
		addToNewFolderSelected: myLibraryActions.addToNewFolderSelected,
	}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(PrivateLibraryAddToFolderModal)
